"use client";

export default function Background() {
  return (
    <div className="cgBackdrop" aria-hidden="true">
      <span className="cgAurora cgAuroraA" />
      <span className="cgAurora cgAuroraB" />
      <span className="cgGrain" />
    </div>
  );
}
